import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon, ZapIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-ink-600 bg-ink-800" data-id="element-79" data-mp="3ggaqfufcyb4x">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "19px",
      paddingBottom: "4px"
    }} data-id="element-80" data-mp="32nummremu92y">
        <div className="flex flex-col items-center gap-6 text-center" data-id="element-81" data-mp="36p6buvtlgsam">
          <p className="flex items-center gap-2 font-display text-lg uppercase text-white" data-id="element-82" data-mp="36nd6rkymqg4q">
            <ZapIcon className="h-5 w-5 text-ball-400" aria-hidden="true" data-id="element-83" data-mp="3ucxpc2qvfbdh" />
            Sigma Smart™
          </p>

          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-84" data-mp="36d2kv7umpm9">
            <li data-id="element-85" data-mp="3qdf7jfucjgev">
              <a href="mailto:soporte.sigmasmart@gmail.com" className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-ball-400" data-id="element-86" data-mp="3qcx8yck7oq3s">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-87" data-mp="2a19uhoqc1syc" />
                soporte.sigmasmart@gmail.com
              </a>
            </li>
            <li data-id="element-88" data-mp="3l8qvi1vp0fqe">
              <a href="https://instagram.com/sigmasmartoficial" className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-ball-400" data-id="element-89" data-mp="3labq1ri0byo9">
                <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="3v7gg42ez4eac" />
                @sigmasmartoficial
              </a>
            </li>
            <li data-id="element-91" data-mp="3q7u2hrv8gw10">
              <a href="https://www.sigmasmart.store" className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-ball-400" data-id="element-92" data-mp="3q7bxo6ui99hh">
                <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-93" data-mp="34gx5i4oqt84" />
                www.sigmasmart.store
              </a>
            </li>
          </ul>

          <p className="max-w-2xl text-xs leading-relaxed text-slate-600" data-id="element-94" data-mp="huwiqy10k36t">
            © Sigma Smart™ 2026 — Todos los derechos reservados. Prohibida la reproducción y
            redistribución sin autorización expresa. Disponible para todos los países de habla
            hispana.
          </p>
        </div>
      </div>
    </footer>;
}